import {css} from 'lit';
export const styles = css`:host {
  --label-bg: 255 255 255;
  --link-focus-outline-offset: -4px;

  display: block;
  position: relative;
}

main {
  display: grid;
  grid-gap: 4px;
  height: 100%;
}

[count='2'] {
  grid-template-columns: 1fr 1fr;
}

[count='2'] xs-collage-item {
  padding-top: 100%;
}

[count='3'][layout='horizontal'] {
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

[count='3'][layout='horizontal'] xs-collage-item:nth-child(1) {
  grid-row: 1 / 3;
  grid-column: 1 / 3;
  padding-top: 66.666%;
}

[count='3'][layout='horizontal'] xs-collage-item:nth-child(2) {
  grid-row: 3 / 4;
  grid-column: 1 / 2;
}

[count='3'][layout='horizontal'] xs-collage-item:nth-child(3) {
  grid-row: 3 / 4;
  grid-column: 2 / 3;
}

[count='3'][layout='vertical'] {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
}

[count='3'][layout='vertical'] xs-collage-item:nth-child(1) {
  grid-row: 1 / 3;
  grid-column: 1 / 3;
  padding-top: 150%;
}

[count='3'][layout='vertical'] xs-collage-item:nth-child(2) {
  grid-row: 1 / 2;
  grid-column: 3 / 4;
}

[count='3'][layout='vertical'] xs-collage-item:nth-child(3) {
  grid-row: 2 / 3;
  grid-column: 3 / 4;
}

[count='4'][layout='horizontal'] {
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
}

[count='4'][layout='horizontal'] xs-collage-item:nth-child(1) {
  grid-row: 1 / 3;
  grid-column: 1 / 4;
  padding-top: 66.666%;
}

[count='4'][layout='horizontal'] xs-collage-item:nth-child(2) {
  grid-row: 3 / 4;
  grid-column: 1 / 2;
}

[count='4'][layout='horizontal'] xs-collage-item:nth-child(3) {
  grid-row: 3 / 4;
  grid-column: 2 / 3;
}

[count='4'][layout='horizontal'] xs-collage-item:nth-child(4) {
  grid-row: 3 / 4;
  grid-column: 3 / 4;
}

[count='4'][layout='vertical'] {
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
}

[count='4'][layout='vertical'] xs-collage-item:nth-child(1) {
  grid-row: 1 / 4;
  grid-column: 1 / 3;
  padding-top: 150%;
}

[count='4'][layout='vertical'] xs-collage-item:nth-child(2) {
  grid-row: 1 / 2;
  grid-column: 3 / 4;
}

[count='4'][layout='vertical'] xs-collage-item:nth-child(3) {
  grid-row: 2 / 3;
  grid-column: 3 / 4;
}

[count='4'][layout='vertical'] xs-collage-item:nth-child(4) {
  grid-row: 3 / 4;
  grid-column: 3 / 4;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: 0;
  min-width: 10vw;
  height: 10vw;
  padding: 4px;
  border: none;
  background-color: rgb(var(--label-bg) / 90%);
  color: var(--text-dark);
  font-weight: 600;
  font-size: 5vw;
  text-decoration: none;
  z-index: 1;
}

@media (min-width: 768px) {
  button {
    min-width: 2em;
    height: 2em;
    font-size: 2em;
  }
}

@media (hover: hover) {
  button:hover {
    background-color: rgb(var(--label-bg) / 80%);
    color: var(--text-dark);
  }
}

button:active {
  background-color: rgb(var(--label-bg) / 90%);
}
`;
export default styles;
